import { useState, useEffect } from "react";

const TruncatedTextWithTooltip = ({ text, maxLines }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  // console.log("maxLines", maxLines);
  return (
    <div className="relative w-fit mx-auto">
      {/* Truncated Text */}
      <h3
        className={`text-[1.4dvh] font-bold text-center cursor-pointer transition-all line-clamp-3 overflow-hidden `}
        onClick={() => setShowTooltip(!showTooltip)}
      >
        {text}
      </h3>

      {/* Tooltip (Full Text) */}
      {showTooltip && (
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full text-[1.4dvh]   mb-2 w-max max-w-xs p-2 bg-gray-800/80 text-white font-semibold rounded-[.7dvh] shadow-[1dvh]">
          {text}
        </div>
      )}
    </div>
  );
};

export default function ServicesCard({
  item,
  handleGetEmployees,
  serviceSelectedId,
}) {
  const [isActive, setIsActive] = useState(false);

  // Use useEffect to toggle `isActive` based on `serviceSelectedId`
  useEffect(() => {
    if (serviceSelectedId === item?.id) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [serviceSelectedId, item?.id]);

  return (
    <div
      // Add an ID to this div for positioning the tooltip
      className="relative cursor-pointer"
      id={`service-${item?.id}`}
    >
      <div className="bg-slate-200 w-[12dvh] h-[12dvh] rounded-full mx-auto">
        <img
          onClick={() => handleGetEmployees(item?.id)}
          className={`object-cover w-full h-full object-center rounded-full duration-500 ${
            isActive
              ? "border-[.5dvh] border-[#A4907C]  fill-[#EFE8E2] opacity-70"
              : ""
          } `}
          src={item?.image || "./images/Service-backup.svg"}
          alt={item?.name}
          loading="lazy"
        />
      </div>
      <div className="my-4 mx-auto w-fit">
        <TruncatedTextWithTooltip
          text={item?.descriptions?.[0]?.name || item?.keyword || "No Name"}
          maxLines={3}
        />
        <p className="text-[1.1dvh]  text-[#A4907C] font-bold text-center">
          {item?.customer_price || "00.00"} SAR
        </p>
      </div>
    </div>
  );
}
